import { Navigate } from 'react-router-dom';

/**
 * /settings redirects straight to /settings/account.
 * The SettingsNav component at the top of each settings sub-page
 * provides navigation between sections.
 */
export function SettingsIndex() {
  return <Navigate to="/settings/account" replace />;
}
